import React, { PropTypes } from 'react';
import { Paper } from 'material-ui';
import TwoColumnRow from '../../tc-ui/two-column-row';
import SaveCancel from '../../tc-ui/save-cancel-buttons';

const GenericRightSideLayout = props => {
  const {
    leftColumnContentText,
    rightColumnContentText,
    mainContent,
    subContent,
    shouldSaveCancelButtonsShow,
    saveCancelOuterDivStyle,
    cancelOnTouchTapFunc,
    saveOnTouchTapFunc,
    shouldSaveButtonBeDisabled,
    isSupplier,
  } = props;

  return (
    <div style={{ overflow: 'visible' }}>
      <Paper
        rounded={false}
        zDepth={1}
        style={isSupplier ? { marginTop: '3%' } : { marginTop: '3%', padding: '3% 5%' }}
      >
        <TwoColumnRow
          outerContainerStyle={{ overflow: 'hidden' }}
          leftColumnClassName="full-width-block-label"
          leftColumnContent={leftColumnContentText}
          leftColumnStyle={isSupplier ?
            {
              height: '48px',
              fontSize: '20px',
              color: 'rgba(0, 0, 0, 0.87)',
              backgroundColor: '#f5f5f5',
              padding: '2%',
              width: '100%',
            } : {
              color: 'rgba(0, 0, 0, 0.87)',
              fontSize: 'calc(12px + 0.5vw)',
              fontWeight: '600',
              padding: '2px',
            }}
          rightColumnContent={rightColumnContentText}
          rightColumnClassName={isSupplier ? 'two-column-row-right-button div-link' : 'two-column-row-right-button'}
          rightColumnStyle={isSupplier ?
            { marginTop: '-35px', cursor: 'pointer' }
            : { height: '32px', top: '1px', position: 'relative', marginRight: '1px' }}
        />
        {mainContent}
        {
          subContent ?
            <div style={{ marginBottom: '50px' }}>
              {subContent}
            </div> : <span/>
        }
        {
          shouldSaveCancelButtonsShow ?
            <SaveCancel
              outerDivStyle={saveCancelOuterDivStyle}
              objectInfoToMap={[
                {
                  labelText: 'Cancel',
                  labelStyle: { color: 'rgba(0, 0, 0, 0.54)', fontWeight: '600', top: '4px' },
                  style: { backgroundColor: '#d8d8d8', height: '32px', width: '80px', borderRadius: '3px', lineHeight: '1.5', marginRight: '20px' },
                  onTouchTap: cancelOnTouchTapFunc,
                },
                {
                  labelText: 'Save',
                  labelStyle: { fontWeight: '600', top: '4px' },
                  style: { height: '32px', width: '80px', borderRadius: '3px', lineHeight: '1.5' },
                  onTouchTap: saveOnTouchTapFunc,
                  disableSave: shouldSaveButtonBeDisabled,
                },
              ]}
            /> : <span/>
        }
      </Paper>
    </div>
  );
};

GenericRightSideLayout.propTypes = {
  leftColumnContentText: PropTypes.string,
  shouldSaveCancelButtonsShow: PropTypes.bool,
  saveCancelOuterDivStyle: PropTypes.object,
  cancelOnTouchTapFunc: PropTypes.func,
  saveOnTouchTapFunc: PropTypes.func,
  shouldSaveButtonBeDisabled: PropTypes.bool,
  subContent: PropTypes.object,
  rightColumnContentText: PropTypes.object,
  mainContent: PropTypes.any,
  isSupplier: PropTypes.bool,
};

export default GenericRightSideLayout;



// WEBPACK FOOTER //
// ./src/app/components/profile/memberships/right-side-layout.jsx